import React from 'react';

import { MaterialButtonWrapper, MaterialContinue } from '@ezbobdev/ui-widgets-ezbob';

import { applyReferralParamsToCasePayload } from '../../utils/common';

const ExpressContinue = (props) => {
  return (
    <MaterialButtonWrapper>
      {/*
        GRN-6047 — inject captured referral params into the case at creation.
        useContinue only invokes overrideCreateCasePayload on the create call
        (the step with shouldCreateCase, e.g. the GL welcome step), so this is a
        no-op on every other Continue. A caller may still override it via props.
      */}
      <MaterialContinue
        fullWidth
        overrideCreateCasePayload={applyReferralParamsToCasePayload}
        {...props}
        stateDriven
        size="large"
      />
    </MaterialButtonWrapper>
  );
};

ExpressContinue.displayName = 'ExpressContinue';

export default ExpressContinue;
